import { Component, OnInit } from '@angular/core';
import { BettingServiceService } from "../../../../services/betting_service/betting-service.service";
import { CommonServiceService } from '../../../../services/common_service/common-service.service';
import videojs from 'video.js';
import { ModalController } from '@ionic/angular';
import { StmgService } from '../../../../services/state_Management/stmg.service';
import { AlertController } from '@ionic/angular';
import { AlertComponent } from '../../../../components/alert/alert.component';
import { TranslateService } from '@ngx-translate/core';
import { interval, Subscription } from 'rxjs';

interface BettingOption {
  id: string;
  label: string;
  odds: string;
  color: string;
  selected: boolean;
  apiId?: number;
  eventId?: number;
  selectionNumber?: number;
}

@Component({
  selector: 'app-keno',
  templateUrl: './keno.component.html',
  styleUrls: ['./keno.component.scss'],
})
export class KenoComponent implements OnInit {

  rouletteVideoUrl: any;
  player: any;
  MAX_SELECTION = 10;
  betSlips: string[] = [];
  drawsCount = 1;
  selectionType: string = 'SP';
  maxCount: boolean = false;
  selectedNumbers: number[] = [];
  totalNumbers: number = 80;
  numbers: any[] = [];
  numberRows: any[][] = [];
  eventData: any = null;

  selection: any = {
    "payload": {
      "@rule": "FeedId86BettingOptions",
      eventSelections: []
    }
  };

  clickCounts: { [key: string]: number } = {};

  bettingOptions: BettingOption[] = [
    { id: 'heads', label: 'Heads', odds: '2.0', color: '#ff5722', selected: false },
    { id: 'evens', label: 'Evens', odds: '4.0', color: '#43a047', selected: false },
    { id: 'tails', label: 'Tails', odds: '2.0', color: '#bf360c', selected: false }
  ];

  kenoVideoUrl: any;
  selectedBets = new Set<string>();
  timerDisplay: string;

  meetingPayload = {
    country: 'KR6',
    date: this.commanService.getCurrentDateTime(),
    filter: 1,
    inplay: false,
    sport: 'VR',
  }

  disable_SP_subscription: Subscription;
  subscription: Subscription;
  mySubscription: Subscription;

  kironNewData: any;
  is_logged = false;
  NextDrowEventCode: string;
  CurrentEventName: string;
  kironResults: any = [];

  currentSelectedBets: any = null;    // Block other races selections

  constructor( public betting_service: BettingServiceService, public translate: TranslateService,
    private commanService: CommonServiceService, private stmgService: StmgService, public alertController: AlertController, public modalController: ModalController) {
      // this.initializeNumbers();
      this.createNumberGrid();

    //refresh when remove all from bet slip modal
    this.disable_SP_subscription = this.commanService.getClickEvent().subscribe(() => {
      this.clearSelection();
    })

    this.stmgService.updateSelections$.subscribe((selection) => {
      
      if(selection && !Array.isArray(selection)){
        if (this.bettingOptions && Array.isArray(this.bettingOptions)) {
          this.bettingOptions.forEach(option => {
            if(Number(selection.selectionNumber) == option.selectionNumber){
                option.selected = false;
                this.betSlips = this.betSlips.filter(item => (parseInt(item)) !== option.apiId);
                this.selection.payload.eventSelections = this.selection.payload.eventSelections.filter((item: any) => parseInt(item.id) !== option.apiId);
            }
          });
        }
      }else if(selection && Array.isArray(selection)){
        selection.forEach((s:any) => {
          this.selectedBets = new Set<string>(
            Array.from(this.selectedBets).filter(value => {
              value !== s.id
            })
          );
        })
      }
    });
  }

  ngOnInit() {
    // Subscribe to login status
    this.stmgService.is_logged_status.subscribe(message => {
      this.is_logged = message;
      // If logged in, initialize video player
      if (this.is_logged) {
        this.initVideoPlayer();
      }
    });

    // get Kiron Meetings
    this.kiron_getMeetings();
    this.get_kiron_results();

    this.stmgService.is_logged_status.subscribe(message =>
      this.is_logged = message
    );

    // this.subscription = this.stmgService.cast_selectedBets.subscribe(selectedBets => {
    //   if (selectedBets) {
    //     this.selection = selectedBets;
    //   }
    // });

    // Block other races selections
    this.stmgService.cast_selectedBets.subscribe(bets => {
      this.currentSelectedBets = bets;
    });
  }

  initVideoPlayer() {
    this.betting_service.getKiron6VideoUrl(this.commanService.getToken()).subscribe((res: any) => {

      // Adjust this according to your API response structure
      this.rouletteVideoUrl = res?.url || res?.videoUrl || res?.data?.url;

      if (!this.rouletteVideoUrl) {
        console.error('Video URL not found in response');
        return;
      }

      setTimeout(() => {
        if (this.player) {
          this.player.dispose();
        }

        this.player = videojs('video-player', {
          controls: true,
          autoplay: false,
          preload: 'auto',
          fluid: true,
          techOrder: ['html5'],
          html5: {
            hls: {
              overrideNative: true,
              withCredentials: false,
            },
            nativeAudioTracks: false,
            nativeVideoTracks: false,
          },
        });

        this.player.src(
          this.rouletteVideoUrl.includes('.m3u8')
            ? { type: 'application/x-mpegURL', src: this.rouletteVideoUrl }
            : { type: 'video/mp4', src: this.rouletteVideoUrl }
        );

        this.player.load();
      }, 0);

    }, error => {
      console.error('Error getting video URL:', error);
    });
  }

  // Video click handler
  onVideoClick() {
    if (!this.is_logged) {
      let alertTitle: string;
      let alertDesc: string;

      this.translate.get('ALERTS.LOGTO_VIDEO.TITLE').subscribe(res => alertTitle = res);
      this.translate.get('ALERTS.LOGTO_VIDEO.DESC').subscribe(res => alertDesc = res);

      const alert = new AlertComponent(this.alertController);
      alert.loginSuccessAlert("", alertTitle, alertDesc);
    }
  }

  //stop the loop
  ngOnDestroy() {
    if (this.player) {
      this.player.dispose(); // clean up
    }
    this.mySubscription?.unsubscribe();
    console.log("unsubsccribe")
    this.disable_SP_subscription.unsubscribe();
  }

  //kiron result method
  get_kiron_results() {
    this.betting_service.getKiron6Result().subscribe(
      (data) => {
        this.kironResults = data[0].events;
        this.kironResults = this.kironResults.reverse();
        // console.log("Keno results: ",  data);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  checkBallColor(item: any) {

    if (item.selectionNumber >= 1 && item.selectionNumber <= 40) {
      return 'yellow';
    }
  
    if (item.selectionNumber > 40 && item.selectionNumber <= 80) {
      return 'red';
    }
  
    return '';
  }

  showPriceTable = false;

  openPriceTable() {
    this.showPriceTable = true;
  }

  closePriceTable() {
    this.showPriceTable = false;
  }

  // get Kiron Meetings
  kiron_getMeetings() {
    this.betting_service.getKenoMeetingDataById(this.meetingPayload).subscribe((data: any) => {
      this.kironGetEventStartTime(data.payload[0].eventLightDTOs);
      this.GetNextDrowEventCode(data.payload[0].eventLightDTOs);
      // console.log("Meeting Response Keno: ", data);
      this.kiron_data(data);
    });
  }


  // get 0th Item from eventLightDTOs
  kiron_data(d: any) {
    let kironMeetings_Data: any = null;
    if (d.status === 'success' && d.payload.length > 0) {
      const events = d.payload[0].eventLightDTOs;
      if (events && events.length > 0) {
        // Get only the 0th item
        kironMeetings_Data = events[0];
      }
    }
    this.getKironsEventByID(kironMeetings_Data);
  }

  // Load Kiron Events
  getKironsEventByID(d: any) {
    const kironEventresult = Array.isArray(d) ? d : (d ? [d] : []);
    kironEventresult.forEach(event => {
      if (!event?.id) return;
      event.selections = [];

      this.betting_service.getEventSelections(event.id).subscribe(data => {
        const selections = Array.isArray(data) ? data : [];
        this.GetEventName(selections);
        event.selections = selections;

        this.processEventSelections(selections, event);
      });
    });

    this.kironNewData = kironEventresult;
  }

  // Get event start time.
  kironGetEventStartTime(meeting) {
    this.betting_service.eventStartTime(meeting[0].id).subscribe((data) => {
      this.kironEventStartTime(data);
    }
    );
  }

  // Event start time
  kironEventStartTime(data) {
    let time = Math.round(data.timeToStartMillis / 1000);
    time = Math.max(time, 0);
    this.timerDisplay = this.formatTime(time);
    // clear previous timer
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
    this.mySubscription = interval(1000).subscribe(() => {
      time = time - 1;
      time = Math.max(time, 0);  
      this.timerDisplay = this.formatTime(time);
      if (time === 0) {
        this.mySubscription.unsubscribe();
        this.kiron_getMeetings();
        this.resetAllSelections();
        return;
      }

    });
  }

  // Time format
  private formatTime(seconds: number): string {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    if (h > 0) {
      return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    }
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  }

  // Get event code
  GetNextDrowEventCode(data:any){
    this.NextDrowEventCode = data[0].eventCode;
  }

  // Get event name
  GetEventName(data: any){
    this.CurrentEventName = data[0].eventName;
  }

  resetAllSelections() {
    this.selectedNumbers = [];
    this.selectedBets.clear();

    if (this.bettingOptions && Array.isArray(this.bettingOptions)) {
      this.bettingOptions.forEach(option => {
        option.selected = false;
      });
    }

    this.betSlips = [];
    this.selection = {
      payload: {
        "@rule": "FeedId86BettingOptions",
        eventSelections: []
      }
    };

    const empty_array = {
      eventSelections: []
    };

    this.clickCounts = {};
    // this.stmgService.updateSelecteBets(this.selection);
    this.stmgService.updateSelecteBets(empty_array);
  }

  // Process Event Selections
  processEventSelections(selections: any[], event: any): void {
    if (!Array.isArray(selections) || selections.length === 0) return;

    const s0 = selections[0];
    this.eventData = {
      eventId: event.id,
      eventName: s0.eventName || '',
      eventCode: s0.eventCode || '',
      meetingName: s0.meetingName || '',
      name: s0.name || '',
      countryCode: s0.countryCode || ''
    };

    const numberSelections = selections.filter(s => s.selectionNumber >= 1 && s.selectionNumber <= 80);
    const optionSelections = selections.filter(s => s.selectionNumber > 80);

    this.numbers = numberSelections.map(s => ({
      id: s.id,
      number: Number(s.name),
      eventId: s.eventId,
      name: s.name,
      selectionNumber: s.selectionNumber,
      countryCode: s.countryCode
    }));

    if (this.numbers?.length) this.createNumberGrid();

    this.updateBettingOptions(optionSelections);
  }
  // initializeNumbers(): void { this.numbers = Array.from({ length: this.totalNumbers }, (_, i) => i + 1); }
  
  // Create Number Grid
  createNumberGrid(): void {
    const rows = [];
    let row = [];

    this.numbers.forEach((n, idx) => {
      row.push(n);

      const i = idx + 1;
      const breakPoints = [9,18,27,36,40,49,58,67,76,80];

      if (breakPoints.includes(i) || i === this.numbers.length) {
        rows.push([...row]);
        row = [];
      }
    });

    this.numberRows = rows;
  }

  // Update Betting Options
  updateBettingOptions(optionSelections: any[]): void {
    optionSelections.forEach(s => {
      const key = s.name.toLowerCase();
      const option = this.bettingOptions.find(o => o.id === key);

      if (option) {
        option.apiId = s.id;
        option.eventId = s.eventId;
        option.selectionNumber = s.selectionNumber;
      }
    });
  }

  // Toggle Number
  toggleNumber(numObj: any): void {
    if (!this.is_logged) {
      this.loginAlert();
      return;
    }

    if (!numObj?.id) return;

    // Block Other selections
    if (this.blockGameSelection()) return;

    const id = numObj.id.toString();

    if (this.selectedBets.has(id)) {
      this.removeFromBetSlip(id);
      return;
    }

    if (this.selectedBets.size >= this.MAX_SELECTION) {
      return this.showMaxCountAlert();
    }

    this.selectedBets.add(id);

    const selectionObj = this.buildSelectionObj(numObj, id);

    this.ensurePayload();
    this.selection.payload.eventSelections.push(selectionObj);
 
    this.betSlips.push(id);
    this.stmgService.updateSelecteBets(this.selection);
    return;
  }

  // Toggle Betting Option
  toggleBettingOption(option: BettingOption): void {
    if (!this.is_logged) {
      this.loginAlert();
      return;
    }

    // Block Other selections
    if (this.blockGameSelection()) return;

    if (option.selected) return;

    // if (this.bettingOptions.some(o => o.selected)) {
    //   return this.showSingleSelectionAlert();
    // }

    // When click heads/evens/tails swicth between 3 options
    if (this.bettingOptions && Array.isArray(this.bettingOptions)) {
      this.bettingOptions.forEach(option => {
        if(option.selected){
          option.selected = false;
          this.betSlips = this.betSlips.filter(item => (parseInt(item)) !== option.apiId);
          this.selection.payload.eventSelections = this.selection.payload.eventSelections.filter(item => parseInt(item.id) !== option.apiId);
        }
      });
    }

    option.selected = true;

    const id = option.apiId?.toString() || option.id.toString();
    this.betSlips.push(id);

    const selectionObj = this.buildOptionObj(option, id);

    this.ensurePayload();
    this.selection.payload.eventSelections.push(selectionObj);

    this.stmgService.updateSelecteBets(this.selection);
    return;
  }

  // Remove Selection
  removeFromBetSlip(id: string) {
    this.betSlips = this.betSlips.filter(b => b !== id);

    this.ensurePayload();
    this.selection.payload.eventSelections =
      this.selection.payload.eventSelections.filter(s => s.id !== id);

    this.selectedBets.delete(id);

    const opt = this.bettingOptions.find(o => o.id.toString() === id);
    if (opt) opt.selected = false;

    this.stmgService.updateSelecteBets(this.selection);
  }

  // Helpers
  buildSelectionObj(numObj: any, id: string) {
    return {
      id,
      eventId: numObj.eventId,
      name: numObj.name,
      eventCode: this.eventData.eventCode,
      meetingName: this.eventData.meetingName,
      eventName: this.eventData.eventName,
      selectionNumber: numObj.selectionNumber,
      countryCode: this.eventData.countryCode
    };
  }

  buildOptionObj(option: BettingOption, id: string) {
    return {
      id,
      name: option.label,
      eventId: option.eventId || this.eventData.eventId,
      eventCode: this.eventData.eventCode,
      meetingName: this.eventData.meetingName,
      eventName: this.eventData.eventName,
      selectionNumber: option.selectionNumber,
      countryCode: this.eventData.countryCode
    };
  }

  ensurePayload() {
    // If selection is totally undefined - create full object
    if (!this.selection) {
      this.selection = {
        payload: {
          "@rule": "FeedId86BettingOptions",
          eventSelections: []
        }
      };
    }

    // If payload missing - recreate with rule
    if (!this.selection.payload) {
      this.selection.payload = {
        "@rule": "FeedId86BettingOptions",
        eventSelections: []
      };
    }

    // If rule missing - add it
    if (!this.selection.payload["@rule"]) {
      this.selection.payload["@rule"] = "FeedId86BettingOptions";
    }

    // If wrong root eventSelections exists - remove it
    if (this.selection.eventSelections) {
      delete this.selection.eventSelections;
    }

    // Ensure array exists
    if (!Array.isArray(this.selection.payload.eventSelections)) {
      this.selection.payload.eventSelections = [];
    }
  }

  // Block Other selections
  blockGameSelection(): boolean {
   // Block other races selections
    if (this.currentSelectedBets && this.currentSelectedBets !== '') {
      // console.log('Keno - Inside check, currentBets exists');

      let hasPayload;

      if(this.currentSelectedBets?.payload){
        hasPayload = this.currentSelectedBets.payload['@rule'] === 'FeedId86BettingOptions';
      }else{
        hasPayload = false;
      }
      
      // console.log('Has Keno Selections :', hasPayload);
      
      if (!hasPayload) {
        let hasRaceBets;

        if(this.currentSelectedBets?.payload){
          hasRaceBets = this.currentSelectedBets.payload.eventSelections.length > 0;
        }else{
          hasRaceBets = this.currentSelectedBets.eventSelections.length > 0;
        }
        
        // console.log('Game - Has Racing or other game Bets:', hasRaceBets);
        
        if (hasRaceBets) {
          this.showBlockAlert();
          return true;
        }
      }
    }

    return false;
  }

  // Getters
  isNumberSelected(n: any): boolean {
    return n?.id && this.selectedBets.has(n.id.toString());
  }

  getSelectedNumbersSorted(): number[] {
    return this.numbers
      .filter(n => this.selectedBets.has(n.id.toString()))
      .map(n => n.number)
      .sort((a,b) => a - b);
  }

  clearSelection(): void {
    this.selectedNumbers = [];
    this.selectedBets.clear();

    if (this.bettingOptions && Array.isArray(this.bettingOptions)) {
      this.bettingOptions.forEach(option => {
        option.selected = false;
      });
    }

    this.betSlips = [];
    this.selection = {
      payload: {
        "@rule": "FeedId86BettingOptions",
        eventSelections: []
      }
    };
    this.clickCounts = {};

    const empty_array = {
      eventSelections: []
    };

    this.stmgService.updateSelecteBets(empty_array);
  }

  // Alerts
  loginAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.PLEASE_LOG.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.PLEASE_LOG.DESC').subscribe((res: string) => {
      alertDesc = res; 
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert(
      "", alertTitle, alertDesc
    ); 
  }

  showMaxCountAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.MAX_COUNT_KENO.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.MAX_COUNT_KENO.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("", alertTitle, alertDesc);
  }

  showSingleSelectionAlert(): void {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.MAX_KENO_OPTIONS.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.MAX_KENO_OPTIONS.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("", alertTitle, alertDesc);
  }

  // Block Other Races
  showBlockAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.BLOCK_SELECTIONS.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.BLOCK_SELECTIONS.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("", alertTitle, alertDesc);
  }

}
